import Vue from "vue";
import VueI18n from "vue-i18n";
import { getDefaultSupportedLocale } from "@/store/modules/i18n";

Vue.use(VueI18n);

export default new VueI18n({
  locale: getDefaultSupportedLocale(),
  silentTranslationWarn: process.env.NODE_ENV === "production"
});
